import React from "react"

const CuvrdNote = ({ note }) => {
  return <div className="covrd-note">{note}</div>
}

export default CuvrdNote
